<app-header />
<div class="flex-1 flex">
  <app-side-bar />
  <main [class]="'flex-1 p-5 pb-0 border-round-xl ' + mainClass" style="width: 10rem;">
    <router-outlet></router-outlet>        
  </main>
</div>
